/**
 * Priorité d'une tâche personnelle, reprise de la V1 (`high` / `medium` / `low`, `medium` par
 * défaut). L'ordre de la liste est celui de l'importance décroissante.
 */
export const taskPriorities = ['high', 'medium', 'low'] as const;
export type TaskPriority = (typeof taskPriorities)[number];
export const DEFAULT_TASK_PRIORITY: TaskPriority = 'medium';
